import { Button, Group, Modal, Stack, Text } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'

interface CancelOrderConfirmationModalProps {
  opened: boolean
  onClose: () => void
  onConfirm: () => void
  customerName: string
  isLoading?: boolean
}

export function CancelOrderConfirmationModal({
  opened,
  onClose,
  onConfirm,
  customerName,
  isLoading = false,
}: CancelOrderConfirmationModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={(
        <Group gap="xs" align="center">
          <IconAlertTriangle size={20} color="var(--mantine-color-red-6)" />
          <Text fw={600}>Cancel Order</Text>
        </Group>
      )}
      centered
      radius="md"
      size="sm"
    >
      <Stack gap="md">
        <Text size="sm">
          Are you sure you want to cancel
          {' '}
          <strong>
            {customerName}
            's
          </strong>
          {' '}
          order? This action cannot be undone.
        </Text>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <Button
            variant="default"
            onClick={onClose}
            disabled={isLoading}
          >
            Keep Order
          </Button>
          <Button
            color="red"
            onClick={onConfirm}
            loading={isLoading}
          >
            Cancel Order
          </Button>
        </div>
      </Stack>
    </Modal>
  )
}
